export default __webpack_public_path__ + "static/media/moored_logo.4c4afa14.png";